import type { SavedListProps } from "./types-saved-list";
import { useFilterPanelSavedList } from "./use-saved-list";
import { FilterPanelSavedListView } from "./view-saved-list";

/** Campo "Filtros Salvos" (para o `Header`): escolher preenche o painel; com um salvo ativo, mostra a lixeira. */
export function FilterPanelSavedList(props: SavedListProps) {
  const viewModel = useFilterPanelSavedList(props);

  return <FilterPanelSavedListView {...viewModel} />;
}
FilterPanelSavedList.displayName = "FilterPanel.SavedList";
